<template>
  <v-footer dark padless>
    <v-card flat tile class="secondary white--text text-center">
      <v-card-text>
        <v-btn
          v-for="(icon, i) in icons"
          :key="i"
          class="mx-4 white--text"
          :href="icon.link"
          target="_blank"
          icon
        >
          <v-icon size="24px">{{ icon.text }}</v-icon>
        </v-btn>
      </v-card-text>

<!--      <v-card-text class="white&#45;&#45;text pt-0">-->
<!--        Phasellus feugiat arcu sapien, et iaculis ipsum elementum sit amet.-->
<!--        Mauris cursus commodo interdum.-->
<!--      </v-card-text>-->

      <v-divider></v-divider>

      <v-card-text  class="white--text">
        <a href="https://beian.miit.gov.cn" target="_blank" style="text-decoration: none;">
          <strong style="color: #e7e7e7"> 豫ICP备2024070003号 </strong>
        </a>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<style scoped>
.v-card {
  width: 100%;
}
</style>

<script>
export default {
  data: () => ({
    icons: [
      {
        text: "mdi-facebook",
        link: "",
      },
      {
        text: "mdi-twitter",
        link: "",
      },
      {
        text: "mdi-linkedin",
        link: "",
      },
      {
        text: "mdi-instagram",
        link: "https://instagram.com/joabson_arley/",
      },
    ],
  }),
};
</script>
